function getSegment(type){
    switch (type){
        case 'course':
            return 'courses';
        default:
            return 'tickets';
    }
}

export default getSegment;